"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
var _initialValues = require("./form/initialValues");
var _validationSchema = _interopRequireDefault(require("./form/validationSchema"));
var _core = require("@stt-componentes/core");
var _coreV = require("@stt-componentes/core-v2");
var _formik = require("formik");
var _campos = _interopRequireDefault(require("./form/campos"));
var _httpStatusCodes = _interopRequireDefault(require("http-status-codes"));
var _fieldNames = require("./form/fieldNames");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ID_EXAME = 'idExame';
var camposEnderecos = ['municipio', 'uf', 'pais', 'cep', 'logradouro', 'bairro'];
var CAMPOS_PACIENTE = [[{
  nome: 'nome',
  obrigatorio: true,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 6,
    md: 6
  }
}, {
  nome: 'genero',
  obrigatorio: true,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 3,
    md: 3
  }
}, {
  nome: 'dataNascimento',
  obrigatorio: true,
  somenteLeitura: true,
  tamanho: {
    xs: 12,
    sm: 3,
    md: 3
  }
}], [{
  nome: 'cpf',
  obrigatorio: true,
  somenteLeitura: true,
  tamanho: {
    xs: 12,
    sm: 4,
    md: 4
  }
}, {
  nome: 'cns',
  obrigatorio: true,
  somenteLeitura: true,
  tamanho: {
    xs: 12,
    sm: 4,
    md: 4
  }
}, {
  nome: 'raca',
  obrigatorio: false,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 4,
    md: 4
  }
}], [{
  nome: 'nomeMae',
  obrigatorio: false,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 8,
    md: 8
  }
}, {
  nome: 'cep',
  obrigatorio: false,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 4,
    md: 4
  }
}], [{
  nome: 'pais',
  obrigatorio: false,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 4,
    md: 4
  }
}, {
  nome: 'uf',
  obrigatorio: false,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 2,
    md: 2
  }
}, {
  nome: 'municipio',
  obrigatorio: false,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 6,
    md: 6
  }
}], [{
  nome: 'logradouro',
  obrigatorio: false,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 7,
    md: 7
  }
}, {
  nome: 'bairro',
  obrigatorio: false,
  somenteLeitura: false,
  tamanho: {
    xs: 12,
    sm: 5,
    md: 5
  }
}]];
var tratarDadosPaciente = function tratarDadosPaciente(paciente, temEndereco) {
  var base = _objectSpread(_objectSpread({}, _initialValues.initialValues), {}, {
    id: paciente.id,
    id_endereco: paciente.id_endereco_paciente,
    cpf: paciente.cpf || '',
    cns: paciente.cartao_sus || '',
    nome: paciente.nome || '',
    nomeMae: paciente.nome_mae || '',
    dataNascimento: paciente.data_nascimento ? new Date(paciente.data_nascimento) : null,
    genero: paciente.id_sexo ? {
      id: paciente.id_sexo,
      descricao: paciente.sexo
    } : null,
    raca: paciente.id_raca ? {
      id: paciente.id_raca,
      descricao: paciente.raca
    } : null
  });
  if (temEndereco) {
    return _objectSpread(_objectSpread({}, base), {}, {
      municipio: paciente.id_cidade ? {
        id: paciente.id_cidade,
        nome: paciente.cidade
      } : null,
      uf: paciente.id_estado ? {
        id: paciente.id_estado,
        sigla: paciente.estado
      } : null,
      pais: paciente.id_pais ? {
        id: paciente.id_pais,
        nome: paciente.pais
      } : null,
      cep: paciente.cep || '',
      logradouro: paciente.logradouro || '',
      bairro: paciente.bairro || ''
    });
  }
  return base;
};
var Busca = function Busca(props) {
  var strings = props.strings,
    callback = props.callback,
    headers = props.headers,
    usarTipoContato = props.usarTipoContato,
    dadosPaciente = props.dadosPaciente,
    _props$podeEditar = props.podeEditar,
    podeEditar = _props$podeEditar === void 0 ? false : _props$podeEditar,
    _props$customSubmit = props.customSubmit,
    customSubmit = _props$customSubmit === void 0 ? null : _props$customSubmit,
    _props$customTitle = props.customTitle,
    customTitle = _props$customTitle === void 0 ? null : _props$customTitle,
    _props$justificarAlte = props.justificarAlteracao,
    justificarAlteracao = _props$justificarAlte === void 0 ? false : _props$justificarAlte;
  var campoJustificativa = [{
    nome: 'justificativa',
    obrigatorio: justificarAlteracao,
    somenteLeitura: false,
    tamanho: {
      xs: 12
    }
  }];
  var campos = [].concat(CAMPOS_PACIENTE, [justificarAlteracao ? campoJustificativa : []]);
  if (!podeEditar) {
    campos.forEach(function (linha) {
      linha.forEach(function (campo) {
        campo.somenteLeitura = true;
      });
    });
  }
  var schema = (0, _validationSchema["default"])(strings, campos);
  var formRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    initialValues = _useState2[0],
    setInitialValues = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    originalData = _useState4[0],
    setOriginalData = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    temEndereco = _useState6[0],
    setTemEndereco = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    mostrarAlerta = _useState8[0],
    setMostrarAlerta = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState0 = _slicedToArray(_useState9, 2),
    tituloAlerta = _useState0[0],
    setTituloAlerta = _useState0[1];
  var _useState1 = (0, _react.useState)(''),
    _useState10 = _slicedToArray(_useState1, 2),
    mensagemAlerta = _useState10[0],
    setMensagemAlerta = _useState10[1];
  var _useState11 = (0, _react.useState)(''),
    _useState12 = _slicedToArray(_useState11, 2),
    tipoAlerta = _useState12[0],
    setTipoAlerta = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    opcoesAlerta = _useState14[0],
    setOpcoesAlerta = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    onCloseAlerta = _useState16[0],
    setOnCloseAlerta = _useState16[1];
  var _useState17 = (0, _react.useState)(null),
    _useState18 = _slicedToArray(_useState17, 2),
    pacienteDefinitivo = _useState18[0],
    setPacienteDefinitivo = _useState18[1];
  (0, _react.useEffect)(function () {
    if (dadosPaciente) {
      carregarPaciente(dadosPaciente.id);
    }
    return function () {
      callback();
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (pacienteDefinitivo) {
      var treatedData = tratarDadosPaciente(pacienteDefinitivo, !!pacienteDefinitivo.id_endereco_paciente);
      setInitialValues(_objectSpread(_objectSpread({}, treatedData), {}, {
        idExame: dadosPaciente.idExame
      }));
      setOriginalData(treatedData);
      setTemEndereco(!!pacienteDefinitivo.id_endereco_paciente);
    }
  }, [pacienteDefinitivo]);
  var carregarPaciente = function carregarPaciente(id) {
    var url = "".concat(global.gConfig.url_base_utilitarios, "/paciente-definitivo/").concat(id);
    _axios["default"].get(url, {
      headers: headers
    }).then(function (response) {
      var data = response.data;
      if (data) {
        var paciente = data;
        setPacienteDefinitivo(paciente);
      }
    })["catch"](function (err) {
      setTipoAlerta('error');
      setMensagemAlerta(strings.pacienteNaoEncontrado);
      setMostrarAlerta(true);
      setOpcoesAlerta([{
        title: strings.ok,
        onClick: function onClick() {
          return setMostrarAlerta(false);
        }
      }]);
      setOnCloseAlerta(function () {
        return function () {
          return setMostrarAlerta(false);
        };
      });
    })["finally"](function () {
      return setMostrarAlerta(false);
    });
  };
  var getChangedFields = function getChangedFields(original, current) {
    var changes = {};
    Object.keys(current).forEach(function (key) {
      if (key !== _fieldNames.JUSTIFICATIVA && key !== ID_EXAME && JSON.stringify(original[key]) !== JSON.stringify(current[key])) {
        changes[key] = current[key];
      }
    });
    return changes;
  };
  var fecharModalPaciente = function fecharModalPaciente() {
    var atualizarPesquisa = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    callback(atualizarPesquisa);
  };
  var verificarLaudoExames = function verificarLaudoExames(dados, setSubmitting) {
    _axios["default"].get("".concat(global.gConfig.url_base_exames, "/exame/paciente-definitivo/").concat(dadosPaciente.id), {
      headers: headers
    }).then(function (response) {
      var data = response.data;
      var mensagem = [];
      var laudosRecentesAssinados = data.filter(function (exame) {
        return exame.data_assinatura_digital;
      });
      if ((laudosRecentesAssinados === null || laudosRecentesAssinados === void 0 ? void 0 : laudosRecentesAssinados.length) > 0) {
        var protocolos = laudosRecentesAssinados.map(function (exame) {
          return exame.protocolo_rctm;
        }).join(', ');
        mensagem.push(strings.alertaLaudoAssinado.replace('%s', protocolos).replace('%s', global.gConfig.pop_alteracao_paciente_laudo_assinado));
      }
      var laudosAcessados = data.filter(function (exame) {
        return exame.laudo_acessado;
      });
      if ((laudosAcessados === null || laudosAcessados === void 0 ? void 0 : laudosAcessados.length) > 0) {
        var _protocolos = laudosAcessados.map(function (exame) {
          return exame.protocolo_rctm;
        }).join(', ');
        mensagem.push(strings.alertaLaudoAcessado_adm.replace('%s', _protocolos).replace('%s', global.gConfig.pop_alteracao_paciente_laudo_acessado));
      }
      if (mensagem.length > 0) {
        setTituloAlerta(strings.atencao);
        setOpcoesAlerta([{
          title: strings.sim,
          onClick: function onClick() {
            return enviarForm(dados, setSubmitting);
          }
        }, {
          title: strings.nao,
          onClick: function onClick() {
            setMostrarAlerta(false);
          }
        }]);
        setMensagemAlerta(mensagem.join('\n\n'));
        setTipoAlerta('alert');
        setOnCloseAlerta(function () {
          return function () {
            setMostrarAlerta(false);
          };
        });
        setMostrarAlerta(true);
        return;
      }
      enviarForm(dados, setSubmitting);
    })["catch"](function (err) {
      console.log(err);
      setTipoAlerta('error');
      setMensagemAlerta(strings.erroGenerico);
      setMostrarAlerta(true);
      setOpcoesAlerta([{
        title: strings.ok,
        onClick: function onClick() {
          return setMostrarAlerta(false);
        }
      }]);
      setOnCloseAlerta(function () {
        return function () {
          setMostrarAlerta(false);
        };
      });
    });
  };
  var enviarForm = function enviarForm(dados, setSubmitting) {
    setSubmitting(true);
    _axios["default"].put("".concat(global.gConfig.url_base_exames, "/exame/paciente"), dados, {
      headers: headers
    }).then(function (_ref) {
      var data = _ref.data;
      setMostrarAlerta(true);
      setTituloAlerta(strings.sucesso);
      setMensagemAlerta(data.message || strings.operacaoSucesso);
      setTipoAlerta('success');
      setOpcoesAlerta([{
        title: strings.ok,
        onClick: function onClick() {
          return fecharModalPaciente(true);
        }
      }]);
      setOnCloseAlerta(function () {
        return function () {
          return fecharModalPaciente(true);
        };
      });
    })["catch"](function (err) {
      console.log(err);
      var response = err.response;
      var msg = strings.erroGenerico;
      if (response) {
        if (response.status === _httpStatusCodes["default"].BAD_REQUEST) {
          var data = response.data;
          var arrMensagem = [];
          data.errors.forEach(function (error) {
            arrMensagem.push("- ".concat(error.message));
          });
          msg = arrMensagem.join('\n');
          setTituloAlerta(data.message);
        } else {
          setTituloAlerta(strings.erro);
        }
      } else {
        setTituloAlerta(strings.erro);
      }
      setTipoAlerta('error');
      setMensagemAlerta(msg);
      setMostrarAlerta(true);
      setOpcoesAlerta([{
        title: strings.ok,
        onClick: function onClick() {
          return setMostrarAlerta(false);
        }
      }]);
      setOnCloseAlerta(function () {
        return function () {
          return setMostrarAlerta(false);
        };
      });
    })["finally"](function () {
      setSubmitting(false);
    });
  };
  if (!initialValues) return null;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_coreV.SttModal, {
    title: customTitle || strings.correcaoDadosPaciente || 'Correção de Dados do Paciente',
    open: true,
    outModalClose: fecharModalPaciente,
    iconClose: fecharModalPaciente,
    maxWidth: "md",
    fullWidth: true,
    children: /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
      initialValues: initialValues,
      enableReinitialize: true,
      validationSchema: schema,
      innerRef: formRef,
      onSubmit: function onSubmit(data, _ref2) {
        var setSubmitting = _ref2.setSubmitting;
        var diff = getChangedFields(originalData, data);
        setSubmitting(false);
        var teveMudanca = Object.keys(diff).length > 0;
        if (!teveMudanca) {
          setMostrarAlerta(true);
          setTituloAlerta(strings.atencao);
          setMensagemAlerta(strings.nenhumaAlteracaoDetectada);
          setTipoAlerta('alert');
          setOpcoesAlerta([{
            title: strings.ok,
            onClick: function onClick() {
              return setMostrarAlerta(false);
            }
          }]);
          setOnCloseAlerta(function () {
            return function () {
              return setMostrarAlerta(false);
            };
          });
          return;
        }
        if (customSubmit) {
          customSubmit(data, originalData);
          return;
        }
        var dadosEnviar = _objectSpread(_objectSpread({}, data), {}, _defineProperty({
          id_endereco_paciente: originalData.id_endereco,
          id: originalData.id
        }, _fieldNames.JUSTIFICATIVA, data.justificativa));
        setMostrarAlerta(true);
        setTituloAlerta(strings.atencao);
        setMensagemAlerta(strings.confirmarEnviarCorrecaoPaciente);
        setTipoAlerta('alert');
        setOpcoesAlerta([{
          title: strings.sim,
          onClick: function onClick() {
            setMostrarAlerta(false);
            verificarLaudoExames(dadosEnviar, setSubmitting);
          }
        }, {
          title: strings.nao,
          onClick: function onClick() {
            return setMostrarAlerta(false);
          }
        }]);
        setOnCloseAlerta(function () {
          return function () {
            return setMostrarAlerta(false);
          };
        });
      }
    }, function (_ref3) {
      var isSubmitting = _ref3.isSubmitting,
        handleSubmit = _ref3.handleSubmit,
        errors = _ref3.errors,
        submitCount = _ref3.submitCount;
      var camposForm = _toConsumableArray(temEndereco ? campos : campos.filter(function (campo) {
        return !camposEnderecos.includes(campo.name);
      }));
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit,
        noValidate: true
      }, /*#__PURE__*/_react["default"].createElement(_campos["default"], {
        strings: strings,
        campos: camposForm,
        contextoCadastroBasico: false,
        pacientePadrao: false,
        usarTipoContato: usarTipoContato,
        headers: headers,
        dadosCadastroOriginal: initialValues,
        errors: errors,
        submitCount: submitCount
      }), /*#__PURE__*/_react["default"].createElement(_core.SttLoading, {
        open: isSubmitting,
        text: strings.atualizandoPaciente
      }));
    }),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, podeEditar && /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
      variant: "contained",
      color: "primary",
      type: "button",
      onClick: function onClick() {
        var _formRef$current;
        formRef === null || formRef === void 0 || (_formRef$current = formRef.current) === null || _formRef$current === void 0 || _formRef$current.submitForm();
      }
    }, strings.salvar), /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
      variant: "outlined",
      color: "primary",
      type: "button",
      onClick: fecharModalPaciente
    }, strings.fechar))
  }), /*#__PURE__*/_react["default"].createElement(_coreV.SttAlerta, {
    open: mostrarAlerta,
    title: tituloAlerta,
    message: mensagemAlerta,
    type: tipoAlerta,
    options: opcoesAlerta,
    onClose: onCloseAlerta
  }));
};
Busca.propTypes = {
  strings: _propTypes["default"].object.isRequired,
  usarTipoContato: _propTypes["default"].bool,
  callback: _propTypes["default"].func.isRequired,
  headers: _propTypes["default"].object.isRequired,
  campos: _propTypes["default"].object
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Busca);